import {ConsentCategory} from '@/helpers/tracking/consent';

/**
 * Inhalte des Cookie-Banners. Nur tatsächlich eingesetzte Dienste
 * (siehe helpers/tracking/destinations.ts, helpers/meta/*, Tracker-Service).
 * Speicherdauern: Herstellerangaben bzw. Werte aus dem eigenen Code.
 * Bei Änderungen an Anbietern/Zwecken CONSENT_REVISION (helpers/tracking/consent.ts) erhöhen.
 */

export type ConsentProvider = {
    name: string;
    company: string;
    purpose: string;
    /** Wo der Dienst eingesetzt wird */
    scope: string;
    /** Cookies/Speicherdauer */
    storage: string;
    /** Hinweis auf Drittlandübermittlung (leer = keine) */
    thirdCountry?: string;
};

export type ConsentCategoryInfo = {
    key: ConsentCategory | 'functional';
    title: string;
    icon: string;
    tone: string;
    description: string;
    required?: boolean;
    providers: ConsentProvider[];
};

const USA_NOTE = 'Daten können in die USA (Drittland) übermittelt werden. Ein Zugriff durch US-Behörden kann nicht ausgeschlossen werden.';

export const CONSENT_CATEGORIES: ConsentCategoryInfo[] = [
    {
        key: 'functional',
        title: 'Notwendig',
        icon: 'mdi-shield-check-outline',
        tone: 'tone-good',
        required: true,
        description: 'Damit Vanilla funktioniert, z. B. für den Login und um deine Cookie-Auswahl zu speichern. Diese Technologien sind immer aktiv.',
        providers: [
            {
                name: 'Cookie-Auswahl',
                company: 'mymusicschool (eigener Dienst)',
                purpose: 'Speichert deine Entscheidung in diesem Banner samt Zeitpunkt, damit wir dich nicht bei jedem Besuch erneut fragen.',
                scope: 'gesamte Website',
                storage: 'Local Storage „cookieSettings“ – bis du deine Auswahl änderst oder die Browserdaten löschst',
            },
        ],
    },
    {
        key: 'statistics',
        title: 'Statistik',
        icon: 'mdi-chart-box-outline',
        tone: 'tone-info',
        description: 'Hilft uns zu verstehen, wie unsere Anmelde- und Bewerbungsstrecken genutzt werden, damit wir sie verbessern können.',
        providers: [
            {
                name: 'Google Analytics 4',
                company: 'Google Ireland Limited',
                purpose: 'Auswertung der Nutzung der Bewerbungsstrecke (z. B. welche Schritte abgeschlossen werden). Google-Werbefunktionen sind deaktiviert. Stimmst du auch Marketing zu, übermitteln wir Ereignisse zusätzlich über unseren Server an Google.',
                scope: 'Bewerbungsstrecke (/bewerben)',
                storage: 'Cookies „_ga“, „_ga_<ID>“ – bis zu 2 Jahre',
                thirdCountry: USA_NOTE,
            },
            {
                name: 'Formular-Statistik',
                company: 'mymusicschool (eigener Dienst)',
                purpose: 'Pseudonyme Kennung, mit der wir die Nutzung unserer Online-Formulare auswerten.',
                scope: 'Online-Formulare',
                storage: 'Cookie „analytics“ – 6 Monate',
            },
        ],
    },
    {
        key: 'marketing',
        title: 'Marketing',
        icon: 'mdi-bullhorn-outline',
        tone: 'tone-purple',
        description: 'Misst, wie gut unsere Anzeigen auf Facebook, Instagram und TikTok funktionieren (z. B. ob nach einem Klick eine Anmeldung oder Bewerbung erfolgt), und hilft, passende Zielgruppen anzusprechen.',
        providers: [
            {
                name: 'Meta Pixel & Conversions API',
                company: 'Meta Platforms Ireland Ltd.',
                purpose: 'Erfolgsmessung unserer Werbung auf Facebook und Instagram, Zielgruppen für Anzeigen. Ereignisse werden zusätzlich über unseren Server an Meta übermittelt, Kontaktdaten nur pseudonymisiert (gehasht).',
                scope: 'Anmeldung (/anmelden) und Bewerbung (/bewerben)',
                storage: 'Cookies „_fbp“, „_fbc“ – bis zu 3 Monate',
                thirdCountry: USA_NOTE,
            },
            {
                name: 'TikTok Pixel & Events API',
                company: 'TikTok Technology Limited',
                purpose: 'Erfolgsmessung unserer Werbung auf TikTok, Zielgruppen für Anzeigen. Ereignisse werden zusätzlich über unseren Server an TikTok übermittelt, Kontaktdaten nur pseudonymisiert (gehasht).',
                scope: 'Bewerbungsstrecke (/bewerben), serverseitig ggf. auch Anmeldung (/anmelden)',
                storage: 'Cookies „_ttp“, „ttcsid*“, „ttclid“, „_tt_enable_cookie“ – bis zu 13 Monate',
                thirdCountry: 'Daten können in Drittländer außerhalb der EU, u. a. in die USA, übermittelt werden. Ein Zugriff durch dortige Behörden kann nicht ausgeschlossen werden.',
            },
        ],
    },
];
